module.exports = __webpack_public_path__ + "static/media/apex-logo-2020-blue.50cdcf05.svg";